import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserBalance } from "../../store/balance/selectors";
import { balanceActions } from "../../store/balance";
import { getUserNews } from "../../store/news/selectors";
import { newsActions } from "../../store/news";
import { HandySvg } from "handy-svg";
import { Link } from "react-router-dom";
import iconRightArrow from "../../assets/icons/svg-sprite/arrow-right.svg";
import iconLeftArrow from "../../assets/icons/svg-sprite/arrow-left.svg";
import iconBottomArrow from "../../assets/icons/svg-sprite/arrow-bottom.svg";
import iconStar from "../../assets/icons/svg-sprite/star.svg";
import iconCross from "../../assets/icons/svg-sprite/close-cross--small.svg";
import iconAttention from "../../assets/icons/svg-sprite/attention.svg";

import BasicPackage from "../../components/basicPackage/basicPackage";
import AdditionalPackage from "../../components/additionalPackage/AdditionalPackage";
import closeBanner from "../../modules/close-banner";
import infoCardsMobileToggler from "../../modules/info-cards-mobile-toggler";
import anchorScrolling from "../../modules/anchor-scrolling";
import infoCardsFeatureTooltip from "../../modules/info-cards-feature-tooltip";
import fixedMessage from "../../modules/fixed-message";
import { cards, user } from "../../lib/api/api";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const InfoCards = ({
  setLoading,
  card,
  subscriptions,
  basicPackage,
  additionalPackages,
  message,
  setMessage,
  promotions,
  setPromotions,
}) => {
  const [promisedPayment, setPromisedPayment] = useState(0);
  const [loadingPackages, setLoadingPackages] = useState(false);

  const dispatch = useDispatch();
  const balance = useSelector(getUserBalance);
  const news = useSelector(getUserNews);
  let loading =
    card.loading && balance.loading && loadingPackages && news.loading;

  const list = React.useMemo(() => {
    const raw = news?.list;
    return Array.isArray(raw)
      ? raw
      : raw && typeof raw === "object"
      ? Object.values(raw)
      : [];
  }, [news.list]);

  useEffect(() => {
    closeBanner();
    infoCardsMobileToggler();
    anchorScrolling();
    infoCardsFeatureTooltip();
    fixedMessage();
    if (!news.loading) {
      user
        .userNews()
        .then((res) => {
          dispatch(newsActions.setNews({ list: res, loading: true }));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  useEffect(() => {
    if (loading) setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (card.ID !== null) {
      cards
        .promisedPaymentStatus(card.ID)
        .then((res) => {
          setPromisedPayment(res.promise);
        })
        .catch((err) => {
          console.log(err);
        });

      const GROUP_ID = "000000038";
      cards
        .actions(card.ID)
        .then((res) => {
          res.forEach((item) => {
            if (item.group_id === GROUP_ID) {
              setPromotions((prevState) => [...prevState, item]);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [card.ID]);

  useEffect(() => {
    if (card.cardID !== null && !balance.loading) {
      cards
        .balance(card.cardID)
        .then((res) => {
          dispatch(
            balanceActions.setBalance({ ...res.balance, ...{ loading: true } })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [card.cardID, balance.loading]);

  function userServices(userList, subscriptions) {
    let res = [];
    userList.forEach((item) => {
      subscriptions.forEach((elem) => {
        if (elem.billing_service_code === item.service_id) {
          res.push(elem);
        }
      });
    });
    return res;
  }

  function restart() {
    const banner = document.getElementById("messageBanner");
    banner.style.removeProperty("display");
    cards
      .restart(card.ID)
      .then((res) => {
        setMessage(`Карта ${res.card_id} успешно переактивирована!`);
      })
      .catch((err) => {
        setMessage("Ошибка переактивации, попробуйте позже");
        console.log(err);
      });
  }

  function payment() {
    const banner = document.getElementById("messageBanner");
    const ACTIVATE = 1;
    cards
      .promisedPayment(card.ID, ACTIVATE)
      .then((res) => {
        if (res.promise && res.promise === 1) {
          setPromisedPayment(1);
        } else {
          console.log(res);
          banner.style.removeProperty("display");
          setMessage(
            "Обещанный платеж подключить не получилось или он недоступен для карты"
          );
        }
      })
      .catch((err) => {
        console.log(err);
        banner.style.removeProperty("display");
        setMessage(
          "Обещанный платеж подключить не получилось или он недоступен для карты"
        );
      });
  }

  return (
    <>
      {!loading && <div className="preloader__wrapper" />}
      <section
        className="info-cards js-section"
        style={loading ? {} : { position: "absolute", left: "-9999px" }}
      >
        <div className="page-container info-cards__container">
          <div className="info-cards__blocks-container">
            <div className="info-cards__card info-cards__contract">
              <div className="info-cards__heading">
                <span className="info-cards__title title title--sub">
                  Информация о карте
                </span>
              </div>
              <div className="info-cards__body">
                <div className="info-cards__data-wrap">
                  <div className="info-cards__contract-description">
                    <span className="info-cards__plan-name">{card.title}</span>
                    <span className="info-cards__contract-number">
                      Договор {card.cardID}
                    </span>
                  </div>
                  <ul className="info-cards__feature-list">
                    <li
                      className="info-cards__feature-item js-info-cards-feature-tooltip"
                      data-tooltip-content="#info-card"
                    >
                      <span className="info-cards__bonus-mark">
                        <HandySvg
                          className="svg-icon"
                          src={iconStar}
                          width="16"
                          height="16"
                        />
                      </span>
                      <span className="info-cards__feature-name">
                        Участник бонусной программы
                      </span>
                    </li>
                  </ul>
                </div>
                <button
                  onClick={restart}
                  className="info-cards__btn solid-btn solid-btn--blue bttn"
                  type="button"
                >
                  Восстановить вещание
                </button>
              </div>
              <div className="tooltipster-templates">
                <div className="info-cards__tooltip" id="info-card">
                  <div className="info-cards__tooltip-description">
                    Участник бонусной программы
                  </div>
                </div>
              </div>
            </div>
            <div className="info-cards__card info-cards__account mobile-hidden">
              <div className="info-cards__heading">
                <span className="info-cards__title title title--sub">
                  Мой счет
                </span>
                {promisedPayment === 1 ? (
                  <span class="info-cards__title title title--sub">
                    Обещанный платеж включен
                  </span>
                ) : (
                  <Link
                    className="info-cards__link arrow-link arrow-link--blue"
                    onClick={payment}
                    to="javascript:void(0)"
                  >
                    Обещанный платёж
                    <HandySvg
                      className="svg-icon arrow-link__arrow"
                      src={iconRightArrow}
                      width="16"
                      height="16"
                    />
                  </Link>
                )}
              </div>
              <div className="info-cards__body">
                <ul className="info-cards__account-info">
                  <li className="info-cards__account-info-item">
                    <span className="info-cards__account-info-sum number number--lg">
                      {balance.rubles}
                      <span className="info-cards__account-info-unit number__note">
                        рублей
                      </span>
                    </span>
                  </li>
                  <li className="info-cards__account-info-item">
                    <span className="info-cards__account-info-sum number number--lg">
                      {balance.bonuses}
                      <span className="info-cards__account-info-unit number__note">
                        бонусов
                      </span>
                    </span>
                  </li>
                </ul>
                <a
                  className="info-cards__btn solid-btn solid-btn--blue bttn js-anchor-link"
                  href="#my-account"
                >
                  Пополнить счет
                </a>
              </div>
            </div>
            <div className="info-cards__card info-cards__tarif mobile-hidden">
              <div className="info-cards__heading">
                <span className="info-cards__title title title--sub">
                  Основной пакет
                </span>
                {promotions.length > 0 && (
                  <a
                    className="info-cards__link arrow-link arrow-link--blue js-anchor-link"
                    href="#my-actions-tariff"
                  >
                    Изменить
                    <HandySvg
                      className="svg-icon arrow-link__arrow"
                      src={iconRightArrow}
                      width="16"
                      height="16"
                    />
                  </a>
                )}
              </div>
              <div className="info-cards__body">
                <ul className="info-cards__price-list">
                  {Object.keys(basicPackage).length !== 0 && (
                    <BasicPackage
                      data={basicPackage}
                      setLoadingPackages={setLoadingPackages}
                    />
                  )}
                </ul>
              </div>
            </div>
            <div className="info-cards__card info-cards__services mobile-hidden">
              <div className="info-cards__heading">
                <span className="info-cards__title title title--sub">
                  Услуги и доп пакеты
                </span>
                <a
                  className="info-cards__link arrow-link arrow-link--blue js-anchor-link"
                  href="#all-services"
                >
                  Все
                  <HandySvg
                    className="svg-icon arrow-link__arrow"
                    src={iconRightArrow}
                    width="16"
                    height="16"
                  />
                </a>
              </div>
              <div className="info-cards__body">
                <ul className="info-cards__price-list">
                  {userServices(additionalPackages, subscriptions).map(
                    (item, index) =>
                      index > 2 ? (
                        ""
                      ) : (
                        <AdditionalPackage
                          ID={card.ID}
                          data={item}
                          changeMessage={setMessage}
                        />
                      )
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="info-cards__banner-container mobile-hidden">
            {list.length > 1 ? (
              <div className="info-cards__banner-buttons-wrap">
                <button
                  className="info-cards__banner-btn info-cards__btn--prev js-banner-slider-prev-btn"
                  type="button"
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconLeftArrow}
                    width="16"
                    height="16"
                  />
                </button>
                <button
                  className="info-cards__banner-btn info-cards__btn--next js-banner-slider-next-btn"
                  type="button"
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconRightArrow}
                    width="16"
                    height="16"
                  />
                </button>
              </div>
            ) : (
              ""
            )}
            <div className="info-cards__banner-slider info-cards__card">
              <Swiper
                slidesPerView={1}
                modules={[Navigation, Autoplay]}
                navigation={{
                  prevEl: ".js-banner-slider-prev-btn",
                  nextEl: ".js-banner-slider-next-btn",
                }}
                autoplay={{ delay: 3000 }}
              >
                {list.map((item) => (
                  <SwiperSlide>
                    <div className="info-cards__banner">
                      <div className="info-cards__heading">
                        <span className="info-cards__title title title--sub">
                          {item.type}
                        </span>
                      </div>
                      <div
                        className="info-cards__banner-pic-wrap"
                        style={{
                          background: `url(${item.image}) center center/contain no-repeat`,
                        }}
                      ></div>
                      <div className="info-cards__banner-info-wrap">
                        <span className="info-cards__banner-title">
                          {item.name}
                        </span>
                        <p className="info-cards__banner-description">
                          {item.text}
                        </p>
                      </div>
                      {item.link ? (
                        <Link
                          className="info-cards__btn solid-btn solid-btn--blue bttn"
                          to={item.link.href}
                          target="_blank"
                        >
                          {item.link.name}
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <div
            id="messageBanner"
            className="info-cards__message-container js-closing-banner js-fixed-message"
            style={{ display: "none" }}
          >
            <div className="info-cards__message">
              <div className="info-cards__message-content">
                <HandySvg
                  className="svg-icon"
                  src={iconAttention}
                  width="36"
                  height="36"
                />
                <div className="info-cards__message-text">{message}</div>
              </div>
              <button
                className="js-close-btn info-cards__message-btn"
                type="button"
              >
                <HandySvg
                  className="svg-icon"
                  src={iconCross}
                  width="13"
                  height="12"
                />
              </button>
            </div>
          </div>
          <button
            className="info-cards__slide-btn js-info-cards-mobile-toggler-btn"
            type="button"
          >
            <span className="info-cards__slide-btn-text js-btn-text">
              Все данные
            </span>
            <HandySvg
              className="svg-icon js-btn-arrow"
              src={iconBottomArrow}
              width="16"
              height="16"
            />
          </button>
        </div>
      </section>
    </>
  );
};

export default InfoCards;
